export const ConfirmDialogInitValues =  {
    isOpen:false,
    title: '',
    subTitle: '',
    onConfirm: () => {},
    onCancel: () => {},
}